<template>
  <div class="main">
    <div class="title">
      <p>商标信息</p>
    </div>
    <div class="mb-24">
      <el-table :data="brand.tableData" border :header-cell-style="{background: '#EDF0F4',color: '#333'}">
        <el-table-column type="index" label="序号" align="center" width="50" />
        <el-table-column label="商标图案" prop="tmPic" align="center">
          <template slot-scope="scope">
            <img v-if="scope.row.tmPic" :src="scope.row.tmPic" alt="" style="max-width:60px;">
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="商标名称" prop="tmName" align="center">
          <template slot-scope="scope">{{ scope.row.tmName||'--' }}</template>
        </el-table-column>
        <el-table-column label="商标状态" prop="status" align="center">
          <template slot-scope="scope">{{ scope.row.status||'--' }}</template>
        </el-table-column>
        <el-table-column label="申请/注册号" prop="regNo" align="center">
          <template slot-scope="scope">{{ scope.row.regNo||'--' }}</template>
        </el-table-column>
        <el-table-column label="申请日期" prop="appDate" align="center">
          <template slot-scope="scope">{{ scope.row.appDate.slice(0,10)||'--' }}</template>
        </el-table-column>
        <el-table-column label="国际分类" prop="intCls" align="center">
          <template slot-scope="scope">{{ scope.row.intCls||'--' }}</template>
        </el-table-column>
      </el-table>
      <div class="center">
        <pagination :pageNum="brand.pageNum" :total="brand.total" @currentChange="val => handleCurrentChange(val, 1)"/>
      </div>
    </div>
    <div class="title">
      <p>专利信息</p>
    </div>
    <div class="mb-24">
      <el-table :data="patent.tableData" border :header-cell-style="{background: '#EDF0F4',color: '#333'}">
        <el-table-column type="index" label="序号" align="center" width="50" />
        <el-table-column label="专利类型" prop="patentType" align="center">
          <template slot-scope="scope">{{ scope.row.patentType||'--' }}</template>
        </el-table-column>
        <el-table-column label="公开（公告）号" prop="pubnumber" align="center">
          <template slot-scope="scope">{{ scope.row.pubnumber||'--' }}</template>
        </el-table-column>
        <el-table-column label="公开（公告）日期" prop="pubDate" align="center">
          <template slot-scope="scope">{{ scope.row.pubDate||'--' }}</template>
        </el-table-column>
        <el-table-column label="名称" prop="title" align="center">
          <template slot-scope="scope">{{ scope.row.title||'--' }}</template>
        </el-table-column>
      </el-table>
      <div class="center">
        <pagination :pageNum="patent.pageNum" :total="patent.total" @currentChange="val => handleCurrentChange(val, 2)"/>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/'
import { tm, parents } from '../api/index.js'

export default {
  name: 'Intellectual',
  components: {
    Pagination
  },
  data () {
    return {
      name: this.$route.query.name,
      brand: {
        tableData: [],
        pageNum: 1,
        total: 0
      },
      patent: {
        tableData: [],
        pageNum: 1,
        total: 0
      }
    }
  },

  mounted () {
    this.tm()
    this.parents()
  },

  methods: {
    tm () {
      var data = {
        name: this.name,
        pageNum: this.brand.pageNum
      }
      tm(data).then(res => {
        if (res.data) {
          this.brand.tableData = res.data.items
          this.brand.total = res.data.total
        } else {
          this.brand.tableData = []
          this.brand.total = 0
        }
      })
    },
    parents () {
      var data = {
        name: this.name,
        pageNum: this.patent.pageNum
      }
      parents(data).then(res => {
        if (res.data) {
          this.patent.tableData = res.data.items
          this.patent.total = res.data.total
        } else {
          this.patent.tableData = []
          this.patent.total = 0
        }
      })
    },
    handleCurrentChange (val, sign) {
      if (sign === 1) {
        this.brand.pageNum = val
        this.tm()
      } else if (sign === 2) {
        this.patent.pageNum = val
        this.parents()
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.title {
  padding: 20px 0;
  p {
    font-size: 16px;
    color: #333;
    border-left: 4px #1890ff solid;
    padding-left: 5px;
    font-weight: bold;
  }
}

.mb-24 {
  margin-bottom: 24px;
}

/deep/.el-table--border,
/deep/.el-table--group {
  border-color: #e1e7ed;
}
/deep/.el-table td,
/deep/.el-table th.is-leaf {
  border-color: #e1e7ed;
}
/deep/.el-table--border th,
/deep/.el-table--border th.gutter:last-of-type {
  border-color: #e1e7ed;
}
/deep/.el-table--border td,
/deep/.el-table--border th {
  border-color: #e1e7ed;
}
</style>
